import thTH from '../../.octopus/th-TH/index.js';

export default {
  TntdNewReference: thTH,
};
